export default "__VITE_ASSET__Lt4Q2RO5__"